import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Layout, DatePicker, Modal } from "antd";
import { Button, ProTableOt } from "../ui/ot";
import { useLocation } from "react-router-dom";

const { Content } = Layout;

const WorkSchedule = () => {
    const location = useLocation();
    const record = location.state?.record;
    const [shift, setShift] = useState("dayoff");
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [selectedOption, setSelectedOption] = useState("新增");
    const [isEditing, setIsEditing] = useState(false);
    const [editingKey, setEditingKey] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [deleteRecord, setDeleteRecord] = useState(null);
    const [data, setData] = useState([
        { key: "1", shift: "早班", startTime: "08:00", endTime: "16:00" },
        { key: "2", shift: "中班", startTime: "16:00", endTime: "00:00" },
        { key: "3", shift: "晚班", startTime: "00:00", endTime: "08:00" },
    ]);

    useEffect(() => {
        console.log("Item Detail:", record);
    }, [record]);

    const handleShiftChange = (event) => {
        setShift(event.target.value);
    };

    const handleStartTimeChange = (value) => {
        setStartTime(value);
    };

    const handleEndTimeChange = (value) => {
        setEndTime(value);
    };

    const handleOptionChange = (value) => {
        setSelectedOption(value);
        if (value === "修改") {
            setIsEditing(true);
        } else {
            setIsEditing(false);
            setEditingKey("");
        }
    };

    const edit = (key) => {
        setIsEditing(true);
        setEditingKey(key);
    };

    const save = () => {
        setIsEditing(false);
        setEditingKey("");
    };

    const cancel = () => {
        setIsEditing(false);
        setEditingKey("");
    };

    const showDeleteConfirm = (record) => {
        setDeleteRecord(record);
        setIsModalVisible(true);
    };

    const handleDelete = () => {
        if (deleteRecord) {
            const newData = data.filter((item) => item.key !== deleteRecord.key);
            setData(newData);
        }
        setIsModalVisible(false);
        setDeleteRecord(null);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setDeleteRecord(null);
    };

    const renderShiftOptions = () => {
        switch (selectedOption) {
            case "新增":
                return (
                    <>
                        <ShiftOptions>
                            <div>班別：</div>
                            <ShiftOption>
                                <input
                                    type="radio"
                                    value="morning"
                                    checked={shift === "morning"}
                                    onChange={handleShiftChange}
                                />
                                早班
                            </ShiftOption>
                            <ShiftOption>
                                <input
                                    type="radio"
                                    value="afternoon"
                                    checked={shift === "afternoon"}
                                    onChange={handleShiftChange}
                                />
                                中班
                            </ShiftOption>
                            <ShiftOption>
                                <input
                                    type="radio"
                                    value="night"
                                    checked={shift === "night"}
                                    onChange={handleShiftChange}
                                />
                                晚班
                            </ShiftOption>
                        </ShiftOptions>
                        {!isEditing && shift === "dayOff" && shift !== "vacation" && (
                            <ShiftTimes>
                                <ShiftTime>
                                    <Label>上班:</Label>
                                    <DatePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm"
                                        value={startTime}
                                        onChange={handleStartTimeChange}
                                    />
                                </ShiftTime>
                                <ShiftTime>
                                    <Label>下班:</Label>
                                    <DatePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm"
                                        value={endTime}
                                        onChange={handleEndTimeChange}
                                    />
                                </ShiftTime>
                            </ShiftTimes>
                        )}
                        {!isEditing && (shift !== "dayOff" || shift === "vacation") && (
                            <ShiftTimes>
                                <ShiftTime>
                                    <Label>日期:</Label>
                                    <DatePicker
                                        format="YYYY-MM-DD"
                                        value={startTime}
                                        onChange={handleStartTimeChange}
                                    />
                                </ShiftTime>
                            </ShiftTimes>
                        )}
                    </>
                );
            case "修改":
                const columns = [
                    { title: "班別", dataIndex: "shift", key: "shift" },
                    {
                        title: "上班時間",
                        dataIndex: "startTime",
                        key: "startTime",
                        render: (_, record) => {
                            return isEditing && editingKey === record.key ? (
                                <DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm"
                                    value={startTime}
                                    onChange={handleStartTimeChange}
                                />
                            ) : (
                                record.startTime
                            );
                        },
                    },
                    {
                        title: "下班時間",
                        dataIndex: "endTime",
                        key: "endTime",
                        render: (_, record) => {
                            return isEditing && editingKey === record.key ? (
                                <DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm"
                                    value={endTime}
                                    onChange={handleEndTimeChange}
                                />
                            ) : (
                                record.endTime
                            );
                        },
                    },
                    {
                        title: "操作",
                        dataIndex: "operation",
                        render: (_, record) => {
                            return isEditing && editingKey === record.key ? (
                                <span>
                                    <StyledButton onClick={save}>儲存</StyledButton>
                                    <StyledButton onClick={cancel}>返回</StyledButton>
                                </span>
                            ) : (
                                <StyledButton onClick={() => edit(record.key)}>
                                    修改
                                </StyledButton>
                            );
                        },
                    },
                ];

                return <ProTableOt columns={columns} dataSource={data} />;
            case "刪除":
                const deleteColumns = [
                    { title: "班別", dataIndex: "shift", key: "shift" },
                    { title: "上班時間", dataIndex: "startTime", key: "startTime" },
                    { title: "下班時間", dataIndex: "endTime", key: "endTime" },
                    {
                        title: "操作",
                        dataIndex: "operation",
                        render: (_, record) => (
                            <StyledButton onClick={() => showDeleteConfirm(record)}>
                                刪除
                            </StyledButton>
                        ),
                    },
                ];

                return (
                    <>
                        <ProTableOt columns={deleteColumns} dataSource={data} />
                        <Modal
                            title="確認刪除"
                            visible={isModalVisible}
                            onOk={handleDelete}
                            onCancel={handleCancel}
                            okText="刪除"
                            cancelText="取消"
                        >
                            <p>您確定要刪除這個班別嗎？</p>
                        </Modal>
                    </>
                );
            default:
                return null;
        }
    };

    return (

        <ContentContainer>
            <Title>班次設定</Title>
            <ShiftOptions>
                <div>班別：</div>
                <ShiftOption>
                    <input
                        type="radio"
                        value="dayOff"
                        checked={shift === "dayOff"}
                        onChange={handleShiftChange}
                    />
                    排班
                </ShiftOption>
                <ShiftOption>
                    <input
                        type="radio"
                        value="vacation"
                        checked={shift === "vacation"}
                        onChange={handleShiftChange}
                    />
                    排休
                </ShiftOption>
            </ShiftOptions>
            <MainContent>
                <Section>
                    <Label>員工資料</Label>
                    <Info>編號: {record.id}</Info>
                    <Info>人員: {record.name}</Info>
                    <Info>工號: {record.employeeNumber}</Info>
                    <Info>性質: {record.employmentType}</Info>
                    <Info>工作時數: {record.workingHours}</Info>
                </Section>
                <Separator />
                <Section>
                    <Label>排班方式:</Label>
                    <ButtonGroup>
                        <OptionButton onClick={() => handleOptionChange("新增")}>
                            新增
                        </OptionButton>
                        <OptionButton onClick={() => handleOptionChange("修改")}>
                            修改
                        </OptionButton>
                        <OptionButton onClick={() => handleOptionChange("刪除")}>
                            刪除
                        </OptionButton>
                    </ButtonGroup>
                    {renderShiftOptions()}
                </Section>
            </MainContent>
        </ContentContainer>

    );
};

const ContentContainer = styled(Content)`
  margin: 24px 16px;
  padding: 24px;
  min-height: 280px;
  background-color: #fff;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;

const Info = styled.div`
  margin-bottom: 5px;
`;

const Separator = styled.hr`
  margin: 20px 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const OptionButton = styled(Button)`
  min-width: 80px;
`;

const ShiftOptions = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const ShiftOption = styled.div`
  margin-right: 20px;
`;

const ShiftTimes = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const ShiftTime = styled.div`
  margin-right: 20px;
`;

const StyledButton = styled(Button)`
  margin-right: 8px;
`;

export default WorkSchedule;
